import { render, staticRenderFns } from "./team-inbox-alert-header.vue?vue&type=template&id=1e867144&scoped=true"
import script from "./team-inbox-alert-header.vue?vue&type=script&lang=js"
export * from "./team-inbox-alert-header.vue?vue&type=script&lang=js"
import style0 from "./team-inbox-alert-header.vue?vue&type=style&index=0&id=1e867144&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e867144",
  null
  
)

export default component.exports